module.exports = __webpack_public_path__ + "static/media/culture-icon.d01312cd.svg";